import _ from "lodash";
import React from "react";
import I18nHOC from "UIComponents/I18nHOC";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";
import { getCriteriaSetOfPypType } from "modules/Services";
import { updateField } from "modules/FieldUpdateThunks";
import { writeAssessmentToolElementLocal } from "modules/AssessmentTool/AssessmentToolModule";
import classes from "./RubricTableV2.scss";
import AssessmentToolAccordionTable from "AppComponents/AssessmentToolAccordionTable";
import { MYP_OBJECTIVE_RUBRIC } from "Constants/stringConstants";
import { getMypIbDefinedCriteriaSet } from "Gradebook/modules/Utils";
import {
  getSelectedAcademicYearId,
  getSelectedCurriculumId,
} from "modules/CommonSelectors";
import classNames from "classnames";
import { readMYPIBDefinedGradeScaleFromCache } from "GradingSetupV2/modules/GradingSetupV2GraphqlHelper";
import { getIsConfigurationEnabledForCPAY } from "modules/PermissionModule";
import { USE_NEW_GRADING_SETUP_IN_COURSE_PERM } from "Constants/permissionConstants";
import { convertMypGradeScaleToCriteriaSet } from "GradingSetupV2/modules/Utils";

const RubricTableV2 = props => {
  const {
    achievementLevels,
    seggregatedObjectives,
    ibPYPElementRatings,
    ratingElementSubType,
    getCriteriaSetOfPypType,
    toolType,
    currentCurriculumProgramId,
    showUpdatedDesign = false,
    isAiEvaluationEnabled,
    showUpdatedDesignForAIGrading,
    mypIbDefinedGradeScale,
    isUsingNewGradingSetupInCourses,
  } = props;

  const seggregatedObjectivesValues = _.values(seggregatedObjectives);

  const subjectLabelClasses = classNames({
    [classes.subjectLabel]:
      !showUpdatedDesign && !showUpdatedDesignForAIGrading,
    ["text-label"]: showUpdatedDesign || showUpdatedDesignForAIGrading,
    [classes.subjectLabelV2]:
      showUpdatedDesign || showUpdatedDesignForAIGrading,
  });

  return (
    <div className={classes.container}>
      {_.map(
        seggregatedObjectivesValues,
        (seggregatedObjectivesValue, index) => {
          const { id, label, children } = seggregatedObjectivesValue || {};

          const isLast = _.size(seggregatedObjectivesValues) - 1 === index;
          return (
            <React.Fragment key={id}>
              {label ? (
                <div className={subjectLabelClasses}>{label}</div>
              ) : null}
              {_.map(children, (child, idx) => {
                let isFirst = idx === 0;
                return _.map(child, (objectives, idx) => {
                  if (toolType === MYP_OBJECTIVE_RUBRIC) {
                    isFirst = idx === 0;
                  }

                  const nonLeafObjective = _.first(
                    _.filter(objectives, objective => !objective?.isLeaf)
                  );

                  const leafObjectives = _.filter(
                    objectives,
                    objective => objective?.isLeaf
                  );

                  const mypObjectiveCriteriaSets = getCriteriaSetOfPypType({
                    type: "MYP_OBJECTIVES",
                    subType: ratingElementSubType,
                  });

                  const criteriaSet = isUsingNewGradingSetupInCourses
                    ? convertMypGradeScaleToCriteriaSet({
                        gradeScale: mypIbDefinedGradeScale,
                        curriculumProgramId: currentCurriculumProgramId,
                      })
                    : getMypIbDefinedCriteriaSet({
                        academicCriteriaSets: mypObjectiveCriteriaSets,
                        curriculumProgramId: currentCurriculumProgramId,
                      });

                  const academicCriteriaValues = _.get(
                    criteriaSet,
                    "academicCriteriaValues",
                    []
                  );

                  const criteriaSetId = _.get(criteriaSet, "id", "");

                  const ibPypElementId = _.get(nonLeafObjective, "id", "");

                  const aiCriteria = _.find(ibPYPElementRatings, rating => {
                    return (
                      _.get(rating, "ibPYPElementId") === ibPypElementId &&
                      _.get(rating, "academicCriteriaSet.id") ===
                        criteriaSetId &&
                      _.get(rating, "creatorType") === "AI" &&
                      !_.get(rating, "isDeleted")
                    );
                  });

                  const staffCriteria = _.find(ibPYPElementRatings, rating => {
                    return (
                      _.get(rating, "ibPYPElementId") === ibPypElementId &&
                      _.get(rating, "academicCriteriaSet.id") ===
                        criteriaSetId &&
                      _.get(rating, "creatorType") === "STAFF"
                    );
                  });

                  const selectedCriteria = isAiEvaluationEnabled
                    ? aiCriteria || staffCriteria
                    : staffCriteria || aiCriteria;

                  const assessmentTool = {
                    criterias: achievementLevels,
                    indicators: leafObjectives,
                    descriptors: _.get(props, "assessmentTool.descriptors", []),
                  };

                  const criteriaLabelClasses = classNames({
                    [classes.criteriaLabel]:
                      !showUpdatedDesign && !showUpdatedDesignForAIGrading,
                    ["text-label"]:
                      showUpdatedDesign || showUpdatedDesignForAIGrading,
                    [classes.criteriaLabelV2]: showUpdatedDesign,
                  });

                  return (
                    <React.Fragment>
                      <div
                        className={criteriaLabelClasses}
                        style={
                          !showUpdatedDesignForAIGrading
                            ? { margin: isFirst ? "8px 0" : "32px 0 8px" }
                            : { margin: isFirst ? "0 0 8px 0" : "16px 0 8px" }
                        }
                      >
                        {_.get(nonLeafObjective, "label")}
                      </div>
                      <AssessmentToolAccordionTable
                        {...props}
                        assessmentTool={assessmentTool}
                        criteriaSetId={criteriaSetId}
                        ibPypElementId={ibPypElementId}
                        selectedCriteria={selectedCriteria}
                        academicCriteriaValues={academicCriteriaValues}
                        criteriaSet={criteriaSet}
                        nonLeafObjective={nonLeafObjective}
                      />
                    </React.Fragment>
                  );
                });
              })}
              {!isLast ? <div className={classes.separator} /> : null}
            </React.Fragment>
          );
        }
      )}
    </div>
  );
};

const mapActionCreators = {
  writeAssessmentToolElementLocal,
  updateField,
  getCriteriaSetOfPypType,
};

const _getSeggregatedObjectives = ({ isEvaluation, objectives }) => {
  if (isEvaluation) {
    const objectivesObj = _.keyBy(objectives, "id");
    const seggregatedObjectives = _.reduce(
      objectives,
      (result, currObj) => {
        if (!currObj.isLeaf) {
          const groupedObjectives = [];
          groupedObjectives.push(currObj);
          const { children } = currObj;
          _.forEach(children, ({ id: childrenId }) => {
            if (objectivesObj[childrenId]) {
              groupedObjectives.push(objectivesObj[childrenId]);
            }
          });
          result.push(groupedObjectives);
        }
        return result;
      },
      []
    );
    return seggregatedObjectives;
  }
  return [objectives];
};

const getSeggregatedObjectives = _.memoize(
  params => _getSeggregatedObjectives(params),
  params => JSON.stringify(params)
);

const _flattenParentChild = nodes => {
  const result = [];

  function flatten(nodes) {
    _.forEach(nodes, node => {
      if (node?.depth !== 1) result.push(node);
      flatten(node?.children);
    });
  }

  flatten(nodes);
  return result;
};

const flattenParentChild = _.memoize(
  params => _flattenParentChild(params),
  params => JSON.stringify(params)
);

const mapStateToProps = (state, ownProps) => {
  const { nestedObjectives = [], isEvaluation = true } = ownProps;

  const currentCurriculumProgramId = getSelectedCurriculumId(state);

  /*
  nestedObjectives = [
    {
      label:"English",
      children:[
        {
          Label:"Listening",
          children: [...]
        }
      ]
    }
  ]

  flattenNodes = [
    {
      Label: "English",
    },
    {
      Label: "Listening"
    }
  ]

  seggregatedObjectives = [
    {
      label:"English",
      children: [
        [[...],[...],[...]],
        [[...],[...]]
      ]
    }
  ]
  */
  const seggregatedObjectives = {};
  _.forEach(nestedObjectives, val => {
    const flattenNodes = flattenParentChild([val]);

    // Zero depth node contains the subject label
    let zeroDepthNode = {};
    const remainingNodes = [];
    _.forEach(flattenNodes, node => {
      if (node?.depth === 0) {
        zeroDepthNode = node;
      } else {
        remainingNodes.push(node);
      }
    });

    const remainingNodesChildren = [];
    _.forEach(remainingNodes, node => {
      if (!seggregatedObjectives[zeroDepthNode?.id]) {
        seggregatedObjectives[zeroDepthNode?.id] = {
          id: zeroDepthNode?.id,
          label: zeroDepthNode?.label,
          children: [],
        };
      }

      remainingNodesChildren.push(node);
    });

    seggregatedObjectives[zeroDepthNode?.id]?.children?.push(
      getSeggregatedObjectives({
        objectives: remainingNodesChildren,
        isEvaluation,
      })
    );
  });

  const academicYearId = getSelectedAcademicYearId(state);

  const isUsingNewGradingSetupInCourses = getIsConfigurationEnabledForCPAY({
    configuration: USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
    curriculumProgramId: currentCurriculumProgramId,
    academicYearId,
  });

  const mypIbDefinedGradeScale = readMYPIBDefinedGradeScaleFromCache({
    curriculumProgramId: currentCurriculumProgramId,
  });

  return {
    userType: state.login.userInfo.user_type,
    seggregatedObjectives,
    isEvaluation,
    currentCurriculumProgramId,
    mypIbDefinedGradeScale,
    isUsingNewGradingSetupInCourses,
  };
};

export default compose(
  I18nHOC({ resource: ["unitPlan", "classRoom"] }),
  connect(mapStateToProps, mapActionCreators)
)(RubricTableV2);
